export const NotSignInError = new Error('Please sign in first. ');
